import { createContext, type ReactNode, useState } from 'react';

const initialState: {
  showPrev?: boolean;
  setShowPrev?: (showPrev: boolean) => void;
  showNext?: boolean;
  setShowNext?: (showNext: boolean) => void;
  isStickyBarVisible?: boolean;
  setStickyBarVisible?: (stickyBarVisible: boolean) => void;
} = {};

const ComparisonContext = createContext(initialState);

const ComparisonContextProvider = ({ children }: { children: ReactNode }) => {
  const [showPrev, setShowPrev] = useState(false);
  const [showNext, setShowNext] = useState(false);
  const [isStickyBarVisible, setStickyBarVisible] = useState(false);

  return (
    <ComparisonContext.Provider
      value={{
        showPrev,
        setShowPrev,
        showNext,
        setShowNext,
        isStickyBarVisible,
        setStickyBarVisible
      }}
    >
      {children}
    </ComparisonContext.Provider>
  );
};

export { ComparisonContext, ComparisonContextProvider };
